import Label from "components/Label";
import StarRating from "components/StarRating";
import React, { FC } from "react";

import styles from "./styles.module.scss";

type Props = {
  stars: number;
  reviewer: string;
  content: string;
  role: string;
  area: string;
};

const ProviderReview: FC<Props> = ({
  stars,
  reviewer,
  content,
  role,
  area
}) => (
  <div className={styles.container}>
    <Label
      className={styles.area}
      color="secondary2"
      variant="xsmall-capitalized-centered"
    >
      {area}
    </Label>
    <StarRating stars={stars} />
    <Label
      className={styles.reviewContent}
      color="secondary"
      variant="small-centered"
    >
      {content}
    </Label>
    <div className={styles.reviewerWrapper}>
      <Label
        className={styles.reviewer}
        color="secondary2"
        variant="xsmall-capitalized-centered"
      >
        {reviewer}
      </Label>
      <Label
        className={styles.role}
        color="secondary2"
        variant="xsmall-capitalized-centered"
      >
        {role}
      </Label>
    </div>
  </div>
);

export default ProviderReview;
